class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (!this.isOpen() || this.detailsContainer.hasAttribute('closing')) return;

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener('click', this.onBodyClickEvent);

    const content = this.querySelector('.search-modal__surface') || this.querySelector('.search-modal');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const releaseScrollLock = () => document.body.classList.remove('overflow-hidden');

    // No animated surface (or motion disabled): close immediately.
    if (!content || prefersReducedMotion) {
      this.detailsContainer.removeAttribute('open');
      releaseScrollLock();
      return;
    }

    // Keep the panel mounted so the exit animation can play, then unmount it.
    this.detailsContainer.setAttribute('closing', '');

    let fallbackTimer;
    const finish = () => {
      clearTimeout(fallbackTimer);
      content.removeEventListener('animationend', onAnimationEnd);
      this.detailsContainer.removeAttribute('open');
      this.detailsContainer.removeAttribute('closing');
      releaseScrollLock();
    };
    const onAnimationEnd = (event) => {
      if (event.target === content) finish();
    };

    content.addEventListener('animationend', onAnimationEnd);
    fallbackTimer = setTimeout(finish, 450);
  }
}

customElements.define('details-modal', DetailsModal);
